function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    clipPath: "url(#clip0_374_911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4998 8.18188V12.0546H15.8817C15.6453 13.3001 14.9361 14.3547 13.8725 15.0637L17.118 17.5819C19.0089 15.8365 20.0998 13.2729 20.0998 10.2274C20.0998 9.51836 20.0362 8.83648 19.918 8.18199L10.4998 8.18188Z",
    fill: "#4285F4",
    style: {
      fill: "#4285F4",
      fill: "color(display-p3 0.2588 0.5216 0.9569)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.89557 11.9036L4.1636 12.4639L1.57265 14.482C3.2181 17.7456 6.59057 20.0002 10.4996 20.0002C13.1996 20.0002 15.4632 19.1093 17.1178 17.5821L13.8723 15.0639C12.9814 15.6639 11.845 16.0275 10.4996 16.0275C7.89965 16.0275 5.69062 14.273 4.89966 11.9093L4.89557 11.9036Z",
    fill: "#34A853",
    style: {
      fill: "#34A853",
      fill: "color(display-p3 0.2039 0.6588 0.3255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.57265 5.51807C0.890868 6.86347 0.5 8.38167 0.5 9.99982C0.5 11.618 0.890868 13.1362 1.57265 14.4816C1.57265 14.4906 4.89998 11.8998 4.89998 11.8998C4.69998 11.2998 4.58177 10.6634 4.58177 9.99972C4.58177 9.336 4.69998 8.69967 4.89998 8.09968L1.57265 5.51807Z",
    fill: "#FBBC05",
    style: {
      fill: "#FBBC05",
      fill: "color(display-p3 0.9843 0.7373 0.0196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.4998 3.98182C11.9726 3.98182 13.2817 4.49089 14.3271 5.47272L17.1907 2.60912C15.4543 0.990971 13.1999 0 10.4998 0C6.59078 0 3.2181 2.24545 1.57265 5.51819L4.89987 8.10001C5.69074 5.73635 7.89985 3.98182 10.4998 3.98182Z",
    fill: "#EA4335",
    style: {
      fill: "#EA4335",
      fill: "color(display-p3 0.9176 0.2627 0.2078)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.13010b44a6d3d85f8292c52915ef242b.svg";
export { ForwardRef as ReactComponent };